import { render, staticRenderFns } from "./_ForgotPassword.vue?vue&type=template&id=541cabf8"
import script from "./_ForgotPassword.vue?vue&type=script&lang=js"
export * from "./_ForgotPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports